import {RangeModel} from '../shared/range.model';
import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class SizeComparisonWordsModel extends QuestionExtendedModel {

  model = {
    firstRange: new RangeModel(),
    possibleAnswers: Enums.SizeComparisonTypes.list(),
    numAnswers: 3,
    imageTypeOne: null
  };

  static generateModel(json: any): SizeComparisonWordsModel {

    const q = new SizeComparisonWordsModel();

    const model = json.model;

    if (model) {

      if (model.firstRange) {
        q.model.firstRange = RangeModel.generateModel(model.firstRange);
      }

      q.model.possibleAnswers = model.possibleAnswers;
      q.model.numAnswers = model.numAnswers;
      q.model.imageTypeOne = model.imageTypeOne;

    }

    return q;

  }

}
